<script setup lang="ts">
defineOptions({ name: "TableLink" });

defineProps<{ to: string }>();
</script>

<template>
  <NuxtLink :to="to" class="table-link">
    <slot />
  </NuxtLink>
</template>

<style scoped lang="scss">
// A name in a table cell reads as text, not as a coloured link — it only picks
// up the accent on hover, and the row's trailing arrow is the real affordance.
.table-link {
  color: inherit;
  text-decoration: none;
  transition: color token("motion-duration-fast") token("motion-ease-standard");

  &:hover {
    color: token("color-content-primary");
  }
}
</style>
